module.exports = __webpack_public_path__ + "img/Discount Icon - charcoal.c49a4190.svg";